import styled from "styled-components";
import { HomeButton } from "../HomeButton";
import { VolumeControl } from "../VolumeControl";
import React from "react";

export const OverlayerControls: React.FC<{ isDown: boolean }> = ({ isDown }) => {
  return (
    <Container>
      <HomeButton />
      {!isDown && <VolumeControl />}
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  top: 51px;
  right: 25px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 11px;

  @media (orientation: portrait) {
    top: 2vh;
    right: unset;
    left: 5vw;
    gap: 3vh;
  }
`;
